import { cx } from '../cx';

/**
 * Loading placeholder. Same geometry as the content it replaces, so nothing
 * jumps when the data lands. Without a `label` it is pure decoration and is
 * hidden from assistive technology; with one it announces itself once.
 */
export type SkeletonShape = 'line' | 'block' | 'circle';

export interface SkeletonProps {
  readonly shape?: SkeletonShape | undefined;
  readonly className?: string | undefined;
  readonly label?: string | undefined;
}

const SHAPES: Record<SkeletonShape, string> = {
  line: 'h-3 w-full rounded-pill',
  block: 'h-20 w-full rounded-surface',
  circle: 'size-8 rounded-pill',
};

export function Skeleton({ shape = 'line', className, label }: SkeletonProps) {
  return (
    <span
      {...(label !== undefined ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true })}
      className={cx(
        'block animate-pulse bg-surface-sunken motion-reduce:animate-none',
        SHAPES[shape],
        className,
      )}
    />
  );
}
